import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALGROUPFINANCE_LOAD_BY_TRIAL_GROUP_ID,
    ACTION_TRIALGROUPFINANCE_LOAD_BY_ID,

    ACTION_TRIALGROUPFINANCE_SAVE,

    ACTION_TRIALGROUPFINANCE_CREATE,

    ACTION_TRIALGROUPFINANCE_VALIDATE,

    ITrialGroupFinanceLoadByTrialGroupIdAction,
    ITrialGroupFinanceLoadByIdAction,
    ITrialGroupFinanceLoadFailureAction,
    ITrialGroupFinanceLoadSuccessAction,

    ITrialGroupFinanceSaveAction,
    ITrialGroupFinanceSaveSuccessAction,
    ITrialGroupFinanceSaveFailureAction,

    ITrialGroupFinanceCreateAction,
    ITrialGroupFinanceCreateSuccessAction,
    ITrialGroupFinanceCreateFailureAction,

    ITrialGroupFinanceValidateAction,
    ITrialGroupFinanceValidateSuccessAction,
    ITrialGroupFinanceValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialGroupFinance";
import { trialGroupFinanceApi } from "../services/trialGroupFinance";

export const
    getTrialGroupFinanceByTrialGroupIdEpic = (action$): Observable<ITrialGroupFinanceLoadSuccessAction | ITrialGroupFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPFINANCE_LOAD_BY_TRIAL_GROUP_ID)
            .mergeMap((action: ITrialGroupFinanceLoadByTrialGroupIdAction) => {
                return trialGroupFinanceApi
                    .getTrialGroupFinanceByTrialGroupId(action.trialGroupId)
                    .map(response =>
                        LoadSuccess(response.trialGroupFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupFinanceByIdEpic = (action$): Observable<ITrialGroupFinanceLoadSuccessAction | ITrialGroupFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPFINANCE_LOAD_BY_ID)
            .mergeMap((action: ITrialGroupFinanceLoadByIdAction) => {
                return trialGroupFinanceApi
                    .getTrialGroupFinanceById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialGroupFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialGroupFinanceEpic = (action$): Observable<ITrialGroupFinanceSaveSuccessAction | ITrialGroupFinanceSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPFINANCE_SAVE)
            .mergeMap((action: ITrialGroupFinanceSaveAction) => {
                return trialGroupFinanceApi
                    .setTrialGroupFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialGroupFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialGroupFinanceEpic = (action$): Observable<ITrialGroupFinanceCreateSuccessAction | ITrialGroupFinanceCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPFINANCE_CREATE)
            .mergeMap((action: ITrialGroupFinanceCreateAction) => {
                return trialGroupFinanceApi
                    .createTrialGroupFinance(action.trialGroupId)
                    .map(response =>
                        CreateSuccess(
                            response.trialGroupFinance,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialGroupFinanceEpic = (action$): Observable<ITrialGroupFinanceValidateSuccessAction | ITrialGroupFinanceValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPFINANCE_VALIDATE)
            .mergeMap((action: ITrialGroupFinanceValidateAction) => {
                return trialGroupFinanceApi
                    .validateTrialGroupFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialGroupFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }